import React from 'react'
import { NotificationUnreadLines } from 'solar-icons'

import { Hint } from '@/components/ui'

export const NoProductsPlaceholder = () => {
  return (
    <div className="flex h-[400px] flex-grow flex-col items-center justify-center gap-4 rounded-lg px-4 md:px-0">
      <NotificationUnreadLines
        className="size-20 text-gray-200"
        strokeWidth={0.6}
      />
      <div className="flex flex-col items-center gap-2 text-center">
        <span className="text-base font-medium">No products found</span>
        <Hint variant="info" className="flex-col lg:flex-row">
          Try selecting a different category or add the product to the system.
        </Hint>
      </div>
    </div>
  )
}
